import { LANDING_BRAND_NAME, LANDING_SECTIONS } from '../constants/posLandingConst';

const NUMBER_WORDS = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];

/**
 * Starts a trial length with a capital, spelling a small leading number out
 * as the design does: '7 days' -> 'Seven days', '14 days' -> '14 days'.
 *
 * @param {string} label
 * @returns {string}
 */
const spellTrial = (label) => label.replace(/^(\d+)/, (digits) => NUMBER_WORDS[Number(digits)] || digits);

/**
 * The closing call to action, and the reminder of where an existing
 * business's till lives.
 *
 * @param {object} props
 * @param {string} props.trialLabel - e.g. '7 days', from the trial plan; '' when there is none
 * @param {() => void} props.onTryFree - selects the free trial on the pricing card
 * @returns {JSX.Element}
 */
function PosLandingFinal({ trialLabel, onTryFree }) {
  // The till address is this same site plus the client id — /<client-id>.
  const host = typeof window !== 'undefined' ? window.location.host : '';

  return (
    <section className="final" id={LANDING_SECTIONS.till}>
      <div className="wrap">
        <h2>Try it on tomorrow&apos;s rush</h2>
        <p>
          {trialLabel ? `${spellTrial(trialLabel)} of everything` : 'Everything'}
          {' '}{LANDING_BRAND_NAME} does, with your own products loaded. No card, no e-wallet, no auto-charge.
        </p>
        <div className="hero-cta">
          <a href={`#${LANDING_SECTIONS.pricing}`} className="btn btn-light btn-lg" onClick={onTryFree}>Try {LANDING_BRAND_NAME} Free</a>
          <a
            href={`#${LANDING_SECTIONS.pricing}`}
            className="btn btn-ghost btn-lg"
            style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)', background: 'transparent' }}
          >
            See pricing
          </a>
        </div>
        <small>Already set up? Open your till at {host}/your-client-id</small>
      </div>
    </section>
  );
}

export default PosLandingFinal;
